import { useTranslation } from "react-i18next";

/** Announces selection count changes to screen readers (polite). */
export function SelectionLiveRegion({ count }: { count: number }) {
  const { t } = useTranslation();
  return (
    <span className="sr-only" aria-live="polite" aria-atomic="true">
      {t("common.selectionCountAnnouncement", { count })}
    </span>
  );
}
